import { Button, Stack, Typography } from '@mui/material'
import { NarrationLang, setNarrationLanguage, warmUpNarration } from '~/utils/narration'

export default function LanguagePreference({ onContinue }: { onContinue: () => void }) {
  const choose = (lang: NarrationLang) => {
    setNarrationLanguage(lang)
    warmUpNarration()
    onContinue()
  }

  return (
    <Stack spacing={3} alignItems="center" justifyContent="center" minHeight="70vh" px={2}>
      <Typography variant="h4" fontWeight={700}>
        Choose your language
      </Typography>
      <Typography variant="h6" color="text.secondary" fontWeight={500}>
        अपनी भाषा चुनें
      </Typography>
      <Typography color="text.secondary">
        This will be used for the voice guidance throughout the process.
      </Typography>
      <Typography color="text.secondary">
        इसका उपयोग पूरी प्रक्रिया में आवाज़ द्वारा मार्गदर्शन के लिए किया जाएगा।
      </Typography>

      <Stack spacing={2} width="100%" maxWidth={320} pt={2}>
        <Button size="large" variant="contained" sx={{ py: 1.5 }} onClick={() => choose('en')}>
          English
        </Button>
        <Button size="large" variant="outlined" sx={{ py: 1.5 }} onClick={() => choose('hi')}>
          हिंदी (Hindi)
        </Button>
      </Stack>
    </Stack>
  )
}
